import smallScaleReportQuery from './view/smallScaleReportQuery.html'

export default {
  base: {
    state: 'declaration.addValTaxSmallScale.smallScaleReportQuery',
    config: {
      url: '/smallScaleReportQuery',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.addValTaxSmallScale.smallScaleReportQuery.list',
      title: '申报报表查询',
    },
  },
  list: {
    state: 'declaration.addValTaxSmallScale.smallScaleReportQuery.list',
    config: {
      url: '/list',
      template: smallScaleReportQuery,
      controller: 'smallScaleReportQueryCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/smallScaleReportQuery/routers.js